import Vue from 'vue'

export default {
  listAction(data) {
    return Vue.axios.get('/api/v1/bo/me/transactions', {params: data }).then((response) => {
      return response.data
    })
  }
}